﻿import { div, span } from 'common/barrels/dom';
import { IDialog, IDialogOptions } from 'runtime/dialogs/dialog';
import { IResourceProvider } from 'common/resourceprovider';

export class RelinquishClaimDialog implements IDialog {
    options: IDialogOptions;
    private dialogContent: JQuery;

    constructor(resources: IResourceProvider, relinquishAction: () => void, keepAction: () => void) {
        this.options = {
            title: resources.getCoreString('RelinquishClaimDialogTitle'),
            width: 520,
            dialogClass: 'wf-container wf-worktray-item-dialog',
            buttons: [
                { text: resources.getCoreString('RelinquishClaimDialogRelinquish'), click: () => { relinquishAction(); this.close(); } },
                { text: resources.getCoreString('RelinquishClaimDialogKeep'), click: () => { keepAction(); this.close(); } }
            ]
        };
        this.dialogContent = div().append(div('form-group').append(span().text(resources.getCoreString('RelinquishClaimDialogText'))));
    }

    content(): JQuery {
        return this.dialogContent;
    }

    close(): void {
        this.dialogContent.dialog('close');
    }
}